import React, { useState } from 'react'
import TobaccoUse from './TobaccoUse/TobaccoUse'
import SocialHistory from './SocialHistory/SocialHistory'
import GenderIdentity from './GenderIdentity/GenderIdentity'
import SexualOrientation from './SexualOrientation/SexualOrientation'

const SocialHistorySection = ({ expandAll, data, setIsRecordSaved, patientID, ...props }) => {
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

    return (
        <div className='content-box px-0'>
            <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
                <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Social History</p>
            </div>
          {expandItems &&
            expandAll &&
                (
                    <div>
                        <TobaccoUse data={data?.TobaccoUse} setIsRecordSaved={setIsRecordSaved}  patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed} />
                        <SocialHistory data={data?.SocialHistory} setIsRecordSaved={setIsRecordSaved}  patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed} />
                        <GenderIdentity data={data?.GenderIdentity} setIsRecordSaved={setIsRecordSaved}  patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed}/>
                        <SexualOrientation data={data?.SexualOrientation} setIsRecordSaved={setIsRecordSaved}  patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed} />
                    </div>)}
        </div>
    )
}

export default SocialHistorySection